// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { css, StyleSheet } from 'aphrodite/no-important'
import PropTypes from 'prop-types'
import React from 'react'

export default function PopoverTextBox(props) {
  const { carerName, details, onClick, timestamp, title } = props

  return (
    <div className={css(classes.container)} onClick={onClick}>
      {timestamp && (
        <div style={styles.greyText}>
          {`${timestamp} • ${carerName.first} ${carerName.last}`}
        </div>
      )}
      <div style={styles.title} className="log-title">
        {title}
      </div>
      <div style={styles.details}>{details}</div>
    </div>
  )
}

PopoverTextBox.propTypes = {
  carerName: PropTypes.object,
  details: PropTypes.string,
  onClick: PropTypes.func,
  timestamp: PropTypes.string,
  title: PropTypes.string
}

const classes = StyleSheet.create({
  container: {
    padding: 8,
    backgroundColor: colors.white,
    borderRadius: 4,
    boxShadow:
      '0 1px 3px hsla(0, 0%, 0%, 0.1), 0 -1px 3px hsla(0, 0%, 0%, 0.1)',
    textAlign: 'left',
    ':hover': {
      cursor: 'pointer'
    },
    ':hover .log-title': {
      textDecoration: 'underline',
      textDecorationColor: colors.pink
    }
  }
})

const styles = {
  details: {
    color: colors.black,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  greyText: {
    color: colors.darkgrey,
    fontSize: 12,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  title: {
    color: colors.black,
    fontWeight: 'bold',
    fontSize: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}
